<script>
import { mapActions } from 'vuex';
import BaseAutocompleteFilter from '@/modules/_global/_components/filters/BaseAutocompleteFilter';

export default {
  name: 'ApartmentFilter',

  extends: BaseAutocompleteFilter,

  methods: {
    ...mapActions('smarthome', ['getApartments']),

    getData() {
      return this.getApartments({ search: this.search }).then(({ data }) => {
        return data.data;
      });
    }
  }
};
</script>
